import React from 'react'

const NotFound = () => {
  return (
    <div>
            <h1>gal</h1>

    </div>
  )
}

export default NotFound
